module.exports = __webpack_public_path__ + "static/media/box-flow.235e3ec4.png";